// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__pGw1y","active":"SwitchDate_active__BduEl"};